const hexToRgba = (alphaHex, opacity) => {
  if (!alphaHex) {
    return "";
  }
  const opacityPercentage = opacity ?? getOpacityFromHex(alphaHex);
  let hexColor = getHexColorFromAlpha(alphaHex)?.replace(/^#/, "") ?? "";
  if (hexColor.length === 3) {
    hexColor = hexColor.split("").map((char) => char + char).join("");
  }
  const bigint = parseInt(hexColor, 16);
  const r = bigint >> 16 & 255;
  const g = bigint >> 8 & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}${opacityPercentage !== void 0 ? `, ${opacityPercentage / 100}` : ""})`;
};
const combineHexWithOpacity = (hexColor, opacityPercentage) => {
  if (!hexColor) {
    return;
  }
  const alpha = Math.round(opacityPercentage / 100 * 255);
  const alphaHex = alpha.toString(16).padStart(2, "0").toUpperCase();
  return `${hexColor?.slice(0, 7)}${alphaHex}`;
};
const getOpacityFromHex = (hexColorWithAlpha) => {
  if (!hexColorWithAlpha || hexColorWithAlpha.length === 7) {
    return 100;
  }
  const hex = hexColorWithAlpha.replace("#", "");
  const alphaHex = hex.slice(6, 8);
  const alphaDecimal = parseInt(alphaHex, 16);
  return Math.round(alphaDecimal / 255 * 100);
};
const getHexColorFromAlpha = (hexColorWithAlpha) => {
  if (!hexColorWithAlpha || hexColorWithAlpha.length === 7) {
    return hexColorWithAlpha;
  }
  return hexColorWithAlpha.slice(0, 7);
};
export {
  combineHexWithOpacity,
  getHexColorFromAlpha,
  getOpacityFromHex,
  hexToRgba
};
//# sourceMappingURL=color-utils.js.map
